import { FC, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { request } from '../../api';
import { showFullscreenMessage } from '../../components/FullscreenMessage';
import { Button, Segment } from '../../kit';
import Avatar from '../../components/Avatar';

const EventListView: FC = (): JSX.Element => {
    const [ events, setEvents ] = useState<any[]>([]);

    const fetch = (): void => {
        request.get('events').then(({ data }) => {
            setEvents(data.data);
        });
    }
    useEffect(() => fetch(), []);

    const subscribe = (event: any): void => {
        request.post(`events/${event.id}/subscribe`).then(({ data }) => {
            fetch();
            showFullscreenMessage(`Je hebt je ${data.copy}!`);
        });
    }

    return (<>
        <h2 className="section-title" data-aos="fade-up">Evenementen</h2>
        <div className="container">
            <div className={styles.grid}>
                {events.map((event) => (
                    <div
                        key={`event-${event.id}`}
                        className={styles.event}
                    >
                        <div>
                            <div className={styles.eventDate}>
                                <span>{event.day}</span>
                                {event.month}
                            </div>
                            <div className={styles.eventMeta}>
                                <a href={`/community/event-${event.id}`}>{event.title}</a><br />
                                {event.time}, {event.location}
                            </div>
                        </div>
                        <Segment className={styles.content}>
                            <div className={styles.description}>
                                {event.shortDescription || 'Geen extra informatie.'}
                                {event.description.length > 100 && (<>
                                    <span>...</span>{' '}
                                    <a href={`/community/event-${event.id}`}>Meer informatie</a>
                                </>)}
                            </div>
                            <div className={styles.buttons}>
                                <Button
                                    color={event.subscribed ? "white" : "primary"}
                                    label={event.subscribed ? 'Je bent aangemeld' : 'Ik ben erbij!'}
                                    onClick={() => subscribe(event)}
                                />
                                <div className={styles.coaches}>
                                    {event.coaches.map((coach: any, index: number) => index < 4 ? (
                                        <a
                                            key={`a-${event.id}-${coach.id}`}
                                            href={`/community/${coach.permalink}`}
                                        >
                                            <Avatar
                                                profile={coach}
                                                size={38}
                                            />
                                        </a>
                                    ) : null)}
                                    {event.coaches.length > 4 && (
                                        <div className={styles.more}>
                                            +{event.coaches.length - 4}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Segment>
                    </div>
                ))}
            </div>
        </div>
    </>);
}

export default EventListView;
